/**
 * The header's one-value title slot — context and reader.
 *
 * Split from the provider component so this module exports no component and
 * the file therefore adds no `react-refresh/only-export-components` warning
 * (the frontend lint budget is 100 and the repo sits at 95; the convention is
 * to fix the warning, not raise the ceiling). See `HeaderTitleContext.tsx`
 * for the provider and the reason the slot exists at all.
 */
import { createContext, useContext, type ReactNode } from 'react';

export interface HeaderTitleValue {
  title: ReactNode | null;
  setTitle: (title: ReactNode | null) => void;
}

export const HeaderTitleContext = createContext<HeaderTitleValue>({
  title: null,
  // A page rendered outside the layout (tests, storybook) publishes into a void.
  setTitle: () => {},
});

export function useHeaderTitle(): HeaderTitleValue {
  return useContext(HeaderTitleContext);
}
